"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIRTUAL_SEGMENT_LEAD = exports.VIRTUAL_SEGMENT_DEFAULT = void 0;
exports.VIRTUAL_SEGMENT_DEFAULT = 'DEFAULT';
exports.VIRTUAL_SEGMENT_LEAD = 'LEAD';
